<template>
  <section
    role="main"
    class="xer-flex xer-content-center xer-flex-wrap xer-justify-center xer-align-items"
  >
    <xer-automation-sync-point value="Unauthorized" />

    <!-- pictogram -->
    <div class="xer-flex xer-justify-center xer-w-full xer-my-10">
      <img class="xer-h-13 tablet:xer-h-15" :src="getPictogramUrl('401')" />
    </div>
    <!-- text -->
    <h1 class="xer-mb-7 xer-heading-xxl xer-text-center">
      {{ rootStore.translate('Moez.Error401.Titel') }}
    </h1>
    <p class="xer-mb-7 xer-block xer-text-center xer-w-full">
      {{ rootStore.translate('Moez.Error401.Beschrijving') }}
    </p>
    <!-- button -->
    <a class="xer-mb-10 xer-btn xer-btn--cta xer-btn--icon" :href="rootStore.xeriusHomeUrl">{{
      rootStore.translate('Moez.Error.Terugknop')
    }}</a>
  </section>
</template>

<script>
import getPictogramUrl from '@/utils/get-pictogram-url';
import XerAutomationSyncPoint from '@/components/XerAutomationSyncPoint';
import applicationInsights from '@/application-insights';
import { mapStores } from 'pinia';
import { useRootStore } from '@/stores';

export default {
  name: 'XerUnauthorized',
  components: {
    XerAutomationSyncPoint
  },
  computed: {
    ...mapStores(useRootStore)
  },
  mounted() {
    applicationInsights.trackPageView('Xerius - Unauthorized', 'Unauthorized', 'XerUnauthorized');
  },
  methods: {
    getPictogramUrl
  }
};
</script>
